import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/hhm.styles.css";

export const HHM = () => {
	return <SubserviceWrapper config={services.hhm} />;
};
